import { FC } from 'react'

import { ClientDashboardItem } from 'share/domain/case'
import CasesListView from 'components/organisms/CasesListView'

interface ReactivateCaseModalProps {
  case: ClientDashboardItem
}

const ReactivateCaseModal: FC<ReactivateCaseModalProps> = ({
  case: reactivateCase
}) => (
  <>
    <h2 className='mb-3'>You are about to reactivate the following case</h2>
    <CasesListView cases={[reactivateCase]} showPopupMenu={false} />
    <h4 className='mt-4'>Are you sure you want to reactivate this case?</h4>
  </>
)

export default ReactivateCaseModal
